import { render } from "./AdminTabs.vue?vue&type=template&id=35d2d821"
import script from "./AdminTabs.vue?vue&type=script&lang=js"
export * from "./AdminTabs.vue?vue&type=script&lang=js"

import "./AdminTabs.vue?vue&type=style&index=0&id=35d2d821&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__